<div [ngClass]="containerClass">
  <img [src]="imageUrl" [ngStyle]="imageStyle"  [ngClass]="imageClass" alt="Image">
  <button id="yourBtn" [ngStyle]="buttonStyle" class="{{ buttonClass }}" (click)="getFile()">
    {{ chooseButtonText }}
  </button>
  <div style='height: 0px;width:0px; overflow:hidden;'><input id="upfile" type="file" value="upload"
      #fileInput (change)="onFileSelected($event)" /></div>
  <div>
  </div>
</div>
